import React, { Component, CSSProperties } from "react";
import classnames from "classnames";

import logoSvg from "../../static/images/logo.svg";
import freeLogoSvg from "../../static/images/logo/formant-free.svg";
import { Logo } from "./Logo";
import * as styles from "./Modal.scss";

export interface IModalProps {
    className?: string;
    fancyBackground?: boolean;
    small?: boolean;
    large?: boolean;
    logo?: boolean;
    children?: React.ReactNode;
    footer?: React.ReactNode;
    frameStyles?: CSSProperties;
    footerStyles?: CSSProperties;
    free?: boolean;
}

export class Modal extends Component<IModalProps> {
    public render() {
        const {
            className,
            fancyBackground,
            children,
            logo,
            footer,
            small,
            large,
            frameStyles,
            footerStyles,
            free,
        } = this.props;
        return (
            <div
                className={classnames(
                    styles.modal,
                    className,
                    fancyBackground && styles["fancy-background"],
                    large && styles.large,
                    small && styles.small,
                )}
            >
                <div className={styles["frame-container"]}>
                    <div className={styles.frame} style={frameStyles}>
                        {(logo === undefined || logo === true) && (
                            <div className={styles.logo}>
                                <Logo src={free ? freeLogoSvg : logoSvg} />
                            </div>
                        )}
                        <div className={styles.content}>{children}</div>
                    </div>

                    {footer && (
                        <div className={styles.footer} style={footerStyles}>
                            <div className={styles.seperator} />
                            <div>{footer}</div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
